"use client";
import CaseStudyPages from "@/components/CaseStudy/CaseStudyPages";

export default function CaseStudyDetailsPage() {
  return <CaseStudyPages />;
}
